export default __webpack_public_path__ + "static/ocean-e9ec7e525fb319f87411bb12c580a7d9.jpg";